import { render, staticRenderFns } from "./BizumRedirect.vue?vue&type=template&id=3629c348&"
import script from "./BizumRedirect.vue?vue&type=script&lang=ts&"
export * from "./BizumRedirect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports